import React,{useContext} from 'react';
import PropTypes from 'prop-types';
import {NavLink,withRouter } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Chip from '@mui/material/Chip';
import ModuleIcon from '@mui/icons-material/PlayArrow';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderIcon from '@mui/icons-material/Folder';

import Functions from '@mui/icons-material/FunctionsTwoTone';
import ReportIcon from '@mui/icons-material/Assessment';
import VoucherIcon from '@mui/icons-material/PostAdd';

import CartIcon from '@mui/icons-material/ShoppingCart';

import ListIcon from '@mui/icons-material/PlaylistAdd';
import UserGroupIcon from '@mui/icons-material/PeopleAlt';
import Avatar from '@mui/material/Avatar';
import AuthContext from "flexbiz-core/components/auth/Context";
import Container from "flexbiz-core/components/Container";
import CartContext  from "./components/CartContext";
import CartForm from "./components/CartForm";

export function Icon({item,...props}){
  const context = useContext(AuthContext)
  const {server_url} = context.config||{}
  let color = (props.style||{}).color || "green";
  let icon = <ModuleIcon  style={{color}}/>;
  if(item){
    if(props.img || item.icon){
      let src = props.img || item.icon;
      if(src && !src.startsWith("http") && !src.startsWith("/images")){
          src = `${server_url}${src}`
      }
      icon = <img src={src} style={{width:24,height:24}}/>
    }else{
      let type = item.type;
      if(!type){
        item.path = item.path || "";
        if(item.path.includes("/dashboard")){
          type="dashboard"
        }else{
          if(item.path.includes("/file")){
            type="file"
          }else{
            if(item.path.includes("/user")){
              type="user"
            }else{
              if(item.path.includes("/calc") || item.path.includes("/tinh")){
                type="calc"
              }else{
                if(item.path.includes("/voucher")){
                  type="voucher"
                }else{
                  if(item.path.includes("/report")){
                    type="report"
                  }else{
                    if(item.path.includes("/list")){
                      type="list"
                    }
                  }
                }
              }
            }
          }
        }
      }
      switch(type){
        case "dashboard":
          icon = <DashboardIcon style={{color}}/>;
          break;
        case "file":
          icon = <FolderIcon style={{color}}/>
          break;
        case "user":
          icon = <UserGroupIcon style={{color}}/>
          break;
        case "calc":
          icon = <Functions  style={{color}}/>;
          break;
        case "voucher":
          icon =<VoucherIcon  style={{color}}/>
          break;
        case "report":
          icon =<ReportIcon  style={{color}}/>
          break;
        case "list":
          icon =<ListIcon  style={{color}}/>
          break;
      }
    }
  }
  if(props.avatar){
    return  <Avatar>{icon}</Avatar>
  }
  return icon
}

Icon.propTypes={
  item: PropTypes.object,
  img: PropTypes.string,
  style: PropTypes.object,
  avatar:PropTypes.bool
}
class VContainer extends React.PureComponent{
  constructor(props){
    super(props);
    this.state={
      title:this.props.title,
      placeholderSearch:this.props.placeholderSearch,
    }
  }
  componentDidMount(){
  }
  componentDidUpdate(oldProps){
    if(this.props.title!=oldProps.title || this.props.placeholderSearch!=oldProps.placeholderSearch ){
      this.setState({title:this.props.title,placeholderSearch:this.props.placeholderSearch});
    }
  }
  openCart(){
    this.props.history.push({pathname: `/cart`,
      search: '',state:{previousLocation: this.props.location}})
  }
   

  render(){
    let {showDrawerIfIsDesktop, ...rest_props} = this.props;
    if(this.context.queryParams.for_agent) showDrawerIfIsDesktop = false;
    
    const has_drawer = !this.context.config?.isMobile
    const {mainTextColor,iconColor,server_url} = this.context.config||{}

    return (
      <Container 
        requireLogin
        showCompanyNameOnHeader ={!this.context.queryParams.for_agent}
        renderComanyName={appInfo=>{
          const avt =(this.context.appInfo.logo?<Avatar src={`${server_url}${this.context.appInfo.logo}`}/>:null);
          return <Tooltip title={appInfo.name}><Chip avatar={avt} style={{maxWidth:150,maxLines:1}} variant="outlined" color="secondary" label={appInfo.short_name || appInfo.name} onClick={()=>{
            this.props.history.push({
              pathname:'/system/appinfo',
              state:{previousLocation:this.props.location}
            })
          }}/></Tooltip>
        }}
        /*appLogo={<img src="/images/logo.png" style={{height:48,marginTop:5}}/>}*/
        showLogoCompany={false}
        linkStyle={{color:mainTextColor}}
        renderHorizontalMenu={this.context.queryParams.for_agent?()=>null:null}
        showDrawerIfIsDesktop ={showDrawerIfIsDesktop}
        title={this.state.title}
        customIcons ={()=>{
          if(!this.context.queryParams.for_agent || this.context.queryParams.for_agent==8) return null;
          return (
            <CartContext.Consumer>
              {({cart}) => <>
                <IconButton onClick={()=>this.openCart()} style={{marginRight:5}} size="large">
                  <Badge badgeContent={cart.map(c=>c.sl_xuat).reduce((a,b)=>Number(a)+Number(b),0)} color="error">
                    <CartIcon style={{color:"white"}}/>
                  </Badge>
                </IconButton>
              </>}
             </CartContext.Consumer>
          );
        }}
        showNotifications={!has_drawer?()=>{
          this.props.history.push({pathname: `/notifications`,
            search: '',state:{previousLocation: this.props.location}})
        }:null}
        drawer={!has_drawer?null:()=>{
          return (
              <List style={{paddingTop:0}}>
                <AuthContext.Consumer>
                  {({modules})=>{
                    if(!modules) return null;
                    modules.forEach(m=>{
                      m.items = (m.items||[]).filter(item=>item.visible!==false && (item.view || item.view_all) && (!item.system || this.context.userInfo.admin));
                    })
                    modules = modules.filter(m=>m.items.length>0 || m.path);
                    return modules.map(module=>{
                      let path = module.path||(module.code.toUpperCase()==="HOME"?"/dashboard":`/m/${module.code}`);
                      let item={path,icon:module.icon}
                      if(item.icon && item.icon.startsWith("/getfile/")){
                        item.img = this.context.config.server_url + item.icon;
                      }
                      return (
                        <ListItem button style={{borderBottom:"1px solid " +this.context.config.secondaryColor}} key={module.code} component={NavLink} to={path} activeStyle={{backgroundColor: "#ddd"}}>
                          <ListItemIcon>
                            <Icon item={item} img={item.img} style={{color:iconColor}}/>
                          </ListItemIcon>
                          <ListItemText  primary={this.context.apis.getLabel(module.title)} />
                          
                        </ListItem>
                      )
                    })
                  }}
                </AuthContext.Consumer>
            </List>
        )
      }}
        style={{height:"100dvh"}} 
        appBarProps={{elevation:this.context.queryParams.for_agent?0:undefined}} {...rest_props}>
        {this.props.children}
        {this.context.queryParams.for_agent && this.context.queryParams.for_agent!=8 && <CartForm forwardedRef={ref=> this.cartRef=ref} />}
      </Container>
    );
  }
}
VContainer.contextType = AuthContext;
VContainer.propTypes={
  children: PropTypes.any,
  match: PropTypes.any,
  history: PropTypes.any,
  location: PropTypes.any,
  title:PropTypes.string,
  placeholderSearch:PropTypes.string,
  showDrawerIfIsDesktop: PropTypes.bool
}
export default  withRouter(VContainer);